<template>
  <section>
    <div class="container is-grid">
      <div class="is-col-12-md">
        <h1>Order Details</h1>
        <div class="subhead-row">
          <p class="header-paragraph">
            Here&rsquo;s everything we know about your order. Please check back for updates. </p>
          <div class="pending-loader-row">
            <img src="@/assets/images/global/pending-icon.png"/>
            <p>Pending</p>
          </div>
        </div>
      </div>
      <div class="is-col-12-md">
        <div class="detail-row">
          <div class="order-column column-1">
            <h2>{{ programName }}</h2>
            <div class="tracking-number-row">
              <p><strong>TrackingNumber</strong></p>
              <p>
                {{ trackingNumber }} </p>
            </div>
            <div class="shipping-address-row">
              <p><strong>Shipping Address</strong></p>
              <p>{{ address1 }}</p>
              <p>{{ address2 }}</p>
              <p>{{ cityInfo }}, {{ stateInfo }}{{ zipCode }}</p>
            </div>
          </div>
          <div class="order-detail-info-mobile">
            <div class="order-row">
              <p>{{ presentationTitle }}</p>
              <p>{{ presentationDate }}</p>
            </div>
            <div class="order-row">
              <p>{{ quantity }}</p>
              <p>{{ quantity }}</p>
            </div>
          </div>
          <div class="order-detail-row" v-if="presentationDate">
            <div class="order-column column-2">
              <ul>
                <li>
                  <p>Date of presentation</p>
                </li>
                <li>
                  <p>Quantity</p>
                </li>
              </ul>
            </div>
            <div class="order-column column-3" v-if="quantity > 0">
              <ul>
                <li>
                  <p>{{ presentationDate }}</p>
                </li>
                <li>
                  <p>{{ quantity }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      programName: this.$store.state.programName,
      trackingNumber: this.$store.state.trackingNumber,
      address1: this.$store.state.address1,
      address2: this.$store.state.address2,
      cityInfo: this.$store.state.cityInfo,
      stateInfo: this.$store.state.stateInfo,
      zipCode: this.$store.state.zipCode,

      presentationDate: this.$store.state.presentation,
      quantity: this.$store.state.quantity,
      presentationTitle: '',
      kitsOrderedTitle: 'Number of kits'
    }
  },
  created () {
    this.getFormData()
  },
  methods: {
    getFormData () {
      const _this = this
      _this.axios.get(
        _this.$apiUrl + 'v1/order/' + _this.$route.params.id,
        _this.$store.state.axiosConfig
      ).then(function (response) {
        if (response.data.errors.length === 0) {
          var o = response.data.order
          _this.order = o
          // Transform some fields into our local format from the API
          _this.trackingNumber = o.ccg_tracking_number
          _this.address1 = o.address_first
          _this.address2 = o.address_second
          _this.cityInfo = o.address_city
          _this.stateInfo = o.address_state
          _this.zipCode = o.address_zip
          _this.presentationDate = o.presentation_date
          _this.quantity = o.quantity
        }
      }).catch(function (error) {
        _this.output = error
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.container {
  display: flex;
  flex-flow: column wrap;
  // padding-left: 2%;
  @media screen and (max-width: 1000px) {
    padding-left: 20px;
    // padding-bottom: 0;
    // height: 118vh;
  }

  h1 {
    font-size: 60px;
    text-transform: uppercase;
    text-align: left;
    margin-top: 65px;
    @media screen and (max-width: 1000px) {
      font-size: 45px;
      text-align: center;
      margin-top: 1.1em;
    }

    @media screen and (max-width: ~"@{mq-xs-bp}") {
      width: 100%;
    }
  }

  h2 {
    @media screen and (max-width: 1000px) {
      font-size: 24px;
    }
  }

  .subhead-row {
    display: flex;
    flex-wrap: wrap;

    .pending-loader-row {
      display: flex;
      margin-top: 0;
      margin-left: 5%;
      @media screen and (max-width: 1000px) {
        // display: none;
        margin-left: 0%;
        margin-top: 40px;
        margin-bottom: 20px;
      }

      img {
        width: 30px;
        margin-right: 10px;
      }

      p {
        color: @color-orange;
        font-weight: 600;
        font-size: 22px;
      }
    }
  }

  .header-paragraph {
    width: 80%;
    @media screen and (max-width: 1000px) {
      width: 100%;
      margin-right: auto;
      font-size: 18px;
    }

    @media screen and (max-width: ~"@{mq-xs-bp}") {
      width: 100%;
      margin-left: 0;
      padding-right: 0px;
    }
  }
}

.order-column {
  width: 50%;

  h2 {
    // padding-left: 20px;
    font-size: 22px;
    margin-bottom: 20px;
    @media screen and (max-width: 1000px) {
      font-size: 20px;
    }
  }

  ul {
    width: auto;
    margin-left: 0;
    border-bottom: none;
    border-top: none;

    li {
      list-style: none;
      border: 1px solid @color-border-lt-gray;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 20px;
      margin-top: 0;

      a {
        font-size: 16px;
      }

      p {
        font-size: 16px;
      }

      &:first-child {
        border-bottom: none;
        border-top: none;
      }

      &:last-child {
        border-bottom: none;
        border-top: none;
      }
    }
  }
}

.column-1 {
  width: 60%;
  @media screen and (max-width: 1000px) {
    width: 100%;
  }

  ul {
    &.header-1 {
      border-right: 1px solid @color-border-lt-gray !important;
      padding-bottom: 20px;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        border: none !important;
      }
    }

    border-right: none;

    li {
      border-left: none;
    }
  }
}

.column-2 {
  width: 40%;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: none;
  }

  ul {
    &.header-2 {
      border-right: 1px solid @color-border-lt-gray !important;
      padding-bottom: 20px;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        border: none !important;
      }
    }

    li {
      p {
        font-weight: 700;
      }
    }
  }
}

.column-3 {
  width: 70%;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: none;
  }

  ul {
    &.header-3 {
      border-right: 1px solid @color-border-lt-gray !important;
      padding-bottom: 20px;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        border: none !important;
      }
    }

    li {
      border-left: none;
      border-right: none;
    }
  }
}

.detail-row {
  display: flex;
  flex: 1 50%;
  justify-content: center;
  @media screen and (max-width: 1000px) {
    display: block;
  }
}

.tracking-number-row {
  margin-top: 40px;
  margin-bottom: 40px;

  p {
    font-size: 16px;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      font-size: 18px;
    }
  }
}

.shipping-address-row {
  margin-top: 40px;
  margin-bottom: 40px;

  p {
    font-size: 16px;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      font-size: 18px;
    }
  }
}

.order-detail-row {
  width: 100%;
  display: flex;
  margin-top: 70px;
  @media screen and (max-width: 1000px) {
    display: none;
  }
}

.order-detail-info-mobile {
  display: none;
  @media screen and (max-width: 1000px) {
    margin-top: 80px;
    display: flex;
    flex-flow: column wrap;
  }

  .order-row {
    margin-bottom: 22px;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      font-family: @open-sans-font;
      font-size: 18px;

      &:first-child {
        font-weight: 700;
      }
    }
  }
}
</style>
